import * as React from "react";
import { useState, useEffect, useRef } from "react";

interface WhitelistButtonType {
  className: string;
  price: number;
  tonPrice: number;
  isLoading: boolean;
  isApplied: boolean;
  onClick: () => void;
}

export default function WhitelistButton({
  className,
  price,
  tonPrice,
  isLoading,
  isApplied,
  onClick,
}: WhitelistButtonType) {
  const [isBlinking, setIsBlinking] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isLoading) return;

    const startBlink = () => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      }
      setIsBlinking(true);
      setTimeout(() => setIsBlinking(false), 700);
    };

    const getRandomInterval = () =>
      Math.floor(Math.random() * (7000 - 5000) + 5000);

    const scheduleNextBlink = () => {
      const nextInterval = getRandomInterval();
      return setTimeout(() => {
        startBlink();
        timer = scheduleNextBlink();
      }, nextInterval);
    };

    let timer = scheduleNextBlink();

    return () => {
      clearTimeout(timer);
    };
  }, [isLoading]);

  const handleClick = () => {
    onClick();
  };

  return (
    <div
      className={`${className} relative button-transition ${isApplied || isLoading ? "cursor-not-allowed opacity-50 pointer-events-none" : "pointer-events-auto cursor-pointer hover:scale-105 transition-all duration-300"}`}
      onClick={!isApplied && !isLoading ? handleClick : undefined}
    >
      <svg
        className="w-full relative z-0"
        width="196"
        height="125"
        viewBox="0 0 196 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99996 0H187.954V7.6179H195.542V117.382H187.954V125H7.99996V117.382H0.412292V7.6179H7.99996V0Z"
          fill={!isApplied ? "#6DC5FF" : "#494949"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.954 3.41597C187.954 5.95527 187.924 8.46433 187.924 11.0036H195.542V117.382H187.954V125H11.6179V117.382C9.0786 117.382 6.5393 117.382 4 117.382V11.0036H11.6179V3.41597L187.954 3.41597Z"
          fill={!isApplied ? "#0099FE" : "#494949"}
        />
      </svg>
      {!isApplied && (
        <video
          ref={videoRef}
          className={`absolute top-0 left-0 w-full h-full z-8 transition-opacity duration-200 ${isBlinking && !isLoading ? "opacity-100" : "opacity-0"}`}
          autoPlay
          muted
          playsInline
          style={{ mixBlendMode: "screen" }}
        >
          <source src="/assets/mint_button_blink.mp4" type="video/mp4" />
        </video>
      )}
      <div className="absolute w-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center z-15 text-center">
        {!isApplied ? (
          <div className="flex flex-col items-center justify-center uppercase">
            <span className={`text-[24px]`}>request to</span>
            <span className={`text-[30px] leading-none`}>whitelist</span>
            <span className={`text-[24px]`}>{price} TON</span>
            <span className={`text-[16px] leading-none opacity-[53%] `}>
              ~{(tonPrice * price).toFixed(2)} $
            </span>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-black uppercase">
            <span className="text-[30px]">whitelist</span>
            <span className="text-[24px]">requested</span>
          </div>
        )}
      </div>
    </div>
  );
}
